import { computed, Injectable, signal } from '@angular/core';
import { Claim, ProviderRole, Role } from '@common/models';
import { AuthState } from '@common/types';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly state = signal<AuthState>({
    availableServices: null,
    authUser: null,
    claims: null,
    defaultObjectLockCount: null,
    modelBasel: null,
    systemInfo: null
  });

  public readonly availableServices = computed(() => this.state().availableServices);
  public readonly authUser = computed(() => this.state().authUser);
  public readonly claims = computed(() => this.state().claims);
  public readonly defaultObjectLockCount = computed(() => this.state().defaultObjectLockCount);
  public readonly modelBasel = computed(() => this.state().modelBasel);
  public readonly systemInfo = computed(() => this.state().systemInfo);

  public readonly providerRoles = computed<ProviderRole[]>(() => this.getRole<ProviderRole>(this.state().claims, 'ProviderRole'));
  public readonly roles = computed<Role[]>(() => this.getRole<Role>(this.state().claims, 'role'));

  patch(partial: Partial<AuthState>): void {
    this.state.update((state) => ({ ...state, ...partial }));
  }

  patchField<K extends keyof AuthState>(key: K, value: AuthState[K]): void {
    this.state.update((state) => ({ ...state, [key]: value }));
  }

  resetCache(): void {
    this.patch({
      availableServices: null,
      authUser: null,
      claims: null,
      defaultObjectLockCount: null,
      modelBasel: null,
      systemInfo: null
    });
  }

  private getRole<T>(claims: Claim[] | null | undefined, type: 'role' | 'ProviderRole'): T[] {
    const roleObj = (claims ?? []).filter((c) => c.Type == type);

    return roleObj.map((c) => c.Value as T);
  }
}
